import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithIntercept } from '@apis/fetchBaseQuery';
import { REQUESTS_PATH } from '@apis/hazard/HazardApi.types';
import { RequestStatusWithData } from '@customTypes/api/api.types';
import { HazardClass } from '@customTypes/order/order.types';

export const hazardApi = createApi({
    reducerPath: 'hazardApi',
    baseQuery: baseQueryWithIntercept,
    endpoints: (builder) => ({
        getHazard: builder.query<RequestStatusWithData<HazardClass[]>, void>({
            query: () => ({ url: REQUESTS_PATH.HAZARD })
        })
    })
});

export const { useGetHazardQuery } = hazardApi;
